package com.wintermar.inspection.feature.domain.model.answer

import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel

data class SummaryAnswerModel(
    val pageTitle: String = "",
    val sectionTitle: String = "",
    val question: InspectionTemplateQuestionModel,
)
